import type { Step } from "react-joyride";

export const qcRecordFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມບັນທຶກຜົນກວດ QC! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້. ຟອມນີ້ຈະຊ່ວຍທ່ານບັນທຶກຜົນການກວດສອບ QC ຕາມມາດຕະຖານ QC ທີ່ເລືອກ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="record-form-inspection-info"]',
    content:
      "ນີ້ແມ່ນພາກຂໍ້ມູນການກວດສອບ. ທ່ານສາມາດໃສ່ວັນທີກວດສອບ, ສະຖານທີ່, ປະເພດງານທີ່ກວດສອບ, ແລະລະຫັດງານ. ຂໍ້ມູນເຫຼົ່ານີ້ຈະຊ່ວຍໃຫ້ທ່ານຈັດການບັນທຶກ QC ໄດ້ຢ່າງມີລະບຽບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-form-items"]',
    content:
      "ນີ້ແມ່ນພາກລາຍການກວດສອບ. ທ່ານຕ້ອງກວດສອບທຸກລາຍການທີ່ຈຳເປັນ (ມີເຄື່ອງໝາຍ *) ໂດຍກົດປຸ່ມ 'ຜ່ານ' ຫຼື 'ບໍ່ຜ່ານ'. ສຳລັບແຕ່ລະລາຍການ, ທ່ານສາມາດເລືອກຮູບພາບ ແລະໃສ່ຫມາຍເຫດໄດ້. ຖ້າມາດຕະຖານ QC ກຳນົດວ່າຕ້ອງມີຮູບພາບ ຫຼືຕ້ອງມີຫມາຍເຫດເມື່ອບໍ່ຜ່ານ, ທ່ານຈະຕ້ອງເລືອກຮູບພາບ ຫຼືໃສ່ຫມາຍເຫດ.",
    placement: "top",
  },
  {
    target: '[data-tourid="record-form-overall-notes"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຫມາຍເຫດທົ່ວໄປ. ທ່ານສາມາດໃສ່ຫມາຍເຫດທົ່ວໄປກ່ຽວກັບການກວດສອບ QC ນີ້ (ບໍ່ບັງຄັບ). ຫມາຍເຫດນີ້ຈະຖືກບັນທຶກກັບບັນທຶກ QC ແລະສາມາດເບິ່ງໄດ້ໃນລາຍລະອຽດບັນທຶກ QC.",
    placement: "top",
  },
  {
    target: '[data-tourid="record-form-status-summary"]',
    content:
      "ນີ້ແມ່ນພາກສະຖິຕິສະຖານະ. ທ່ານຈະເຫັນສະຖານະລວມຂອງການກວດສອບ QC (ຜ່ານ/ບໍ່ຜ່ານ/ກຳລັງກວດສອບ) ແລະຈຳນວນລາຍການທີ່ກວດສອບແລ້ວ. ສະຖານະລວມຈະຖືກຄິດໄລ່ອັດຕະໂນມັດຕາມຜົນການກວດສອບຂອງແຕ່ລະລາຍການ.",
    placement: "top",
  },
  {
    target: '[data-tourid="record-form-submit"]',
    content:
      "ຫຼັງຈາກກວດສອບທຸກລາຍການທີ່ຈຳເປັນແລ້ວ, ກົດປຸ່ມ 'ບັນທຶກຜົນກວດ' (ສຳລັບການສ້າງໃໝ່) ຫຼື 'ບັນທຶກການແກ້ໄຂ' (ສຳລັບການແກ້ໄຂ) ເພື່ອບັນທຶກຜົນກວດ QC. ປຸ່ມນີ້ຈະຖືກເປີດໃຊ້ເມື່ອກວດສອບທຸກລາຍການທີ່ຈຳເປັນແລ້ວ.",
    placement: "top",
  },
];
